export function isLocalHost(url: string) {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1' || parsedUrl.hostname === '::1';
  } catch {
    return false;
  }
}
